<template>
  <v-icon v-if="status.value" class="status-icon" color="green">
    mdi-check-circle-outline
  </v-icon>
  <v-icon v-else :title="status.label" class="status-icon" color="red">
    mdi-close-circle-outline
  </v-icon>
</template>

<script lang="ts">
export default {
  name: 'StatusIcon',
  props: ['status'],
};
</script>

<style lang="scss" scoped></style>
